<template>
  <div class="app-container">
    <div>
      <el-form :inline="true">
        <el-form-item>
          <el-date-picker
            type="datetime"
            placeholder="生产开始"
            v-model="filters.startTime"
            value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
          -
          <el-date-picker
            type="datetime"
            placeholder="生产结束"
            v-model="filters.endTime"
            value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="filters.projectName"
            placeholder="工程名称"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="filters.orgCode"
            placeholder="请选择"
            class="select-org"
          >
            <el-option
              v-for="item in sysList"
              :key="item.Id"
              :label="item.Name"
              :value="item.OrgCode"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="filters.stationLineName"
            placeholder="生产线"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getReportList(1)">查询</el-button>
           <el-button type="primary" @click="downReportManufacture">
          导出
        </el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 主表格 -->
  
      <el-table
        :data="dmList"
        border
        style="width: 100%"
        :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
        v-loading="listLoading"
      >
        <!-- 工程信息列 -->
        <el-table-column prop="ProjectName" label="工程信息" width="180" fixed>
          <template slot-scope="scope">
            <span>{{ scope.row.ProjectName }}</span>
          </template>
        </el-table-column>

        <!-- 生产时间列 -->
        <el-table-column prop="PlcDatetime" label="生产时间" width="155">
          <template slot-scope="scope">
            <span>{{ scope.row.PlcDatetime }}</span>
          </template>
        </el-table-column>

        <!-- 本盘方量列 -->
        <el-table-column prop="volume" label="本盘方量(m³)" width="120">
          <template slot-scope="scope">
          <span>{{ scope.row.ItemQuantity }}</span>
           <el-tag type="info"
            disable-transitions>
            {{ scope.row.MixTime }}S
          </el-tag>
        </template>
        </el-table-column>

        <el-table-column prop="NowItemNum" label="当前盘" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.NowItemNum }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="OrgName" label="站名" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.OrgName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="StationLineName" label="生产线" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.StationLineName }}</span>
          </template>
        </el-table-column>
        <!-- 动态生成物资列 -->
        <template v-for="(material, index) in materials">
          <el-table-column
            :key="material.MatName"
            :label="material.MatName"
            align="center"
          >
            <!-- 设定值行 -->
            <el-table-column label="设定值" width="70">
              <template slot-scope="scope">
                <span>
                  {{
                    findMaterialValue(
                      scope.row.materialList,
                      material.MatName,
                      "Quantity"
                    )
                  }}
                </span>
              </template>
            </el-table-column>

            <!-- 实际值行 -->
            <el-table-column label="实际值" width="70">
              <template slot-scope="scope">
                <span>
                  {{
                    findMaterialValue(
                      scope.row.materialList,
                      material.MatName,
                      "ActualQuantity"
                    )
                  }}
                </span>
              </template>
            </el-table-column>

            <!-- 误差率行 -->
            <el-table-column label="误差率" width="70">
              <template slot-scope="scope">
                <span
                  :style="{
                    color: getErrorRateColor(
                      findMaterialValue(
                        scope.row.materialList,
                        material.MatName,
                        'ErrorRate'
                      )
                    ),
                  }"
                >
                  {{
                    findMaterialValue(
                      scope.row.materialList,
                      material.MatName,
                      "ErrorRate"
                    )
                  }}%
                </span>
              </template>
            </el-table-column>
          </el-table-column>
        </template>
      </el-table>

    <!-- 分页 -->
    <el-pagination
      layout="total, sizes, prev, pager, next, jumper"
      :page-size="filters.intPageSize"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
      class="my-pagination"
    ></el-pagination>
  </div>
</template>

<script>
import * as api from "../../api/command";
import util from "../../../util/date";
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      filters: {
        orgCode: "",
        stationLineName: "",
        projectName: "",
        startTime: "",
        endTime: "",
        page: 1,
        intPageSize: 10,
      },
      sysList: [],
      dmList: [],
      materials: [],
      listLoading: false,

      total: 0,
    };
  },

  methods: {
    // 根据物资名称查找对应的值
    findMaterialValue(materials, matName, field) {
      if (!materials) return "";
      const material = materials.find((item) => item.MatName === matName);
      return material ? material[field] : "";
    },
    //导出原材料消耗
    downReportManufacture() {
      let para = this.filters;
      var sheetName = "每盘耗料明细";
      api.DownReportManufactureInfo(para, sheetName).then((res) => { });
    },
    getReportList(optype) {
      if (optype == 1) {
        this.filters.page = 1;
      }

      if (this.getSysOrgs.length == 1) {
        this.filters.orgCode = this.getSysOrgs[0].OrgCode;
      }
      let para = this.filters;
      this.listLoading = true;
      this.dmList = [];
      api
        .GetReportManufactureInfo(para)
        .then((res) => {
          if (res && res.data && res.data.response && res.data.response.data) {
            this.materials = res.data.response.header;
            this.dmList = res.data.response.data;
            this.total = res.data.response.dataCount;
          }
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    //翻页事件绑定方法
    handleCurrentChange(val) {
      this.filters.page = val;
      this.getReportList();
    },
    //切换分页大小绑定方法
    handleSizeChange(size) {
      this.filters.intPageSize = size;
      this.getReportList(1);
    },

    getErrorRateColor(rate) {
      rate = parseFloat(rate);
      if (Math.abs(rate) > 2) {
        return "#F56C6C"; // 红色表示误差较大
      } else if (Math.abs(rate) > 1) {
        return "#E6A23C"; // 黄色表示误差中等
      } else {
        return "#67C23A"; // 绿色表示误差较小
      }
    },
  },
  mounted() {
    var currentDate = new Date();
    if (!this.filters.startTime) {
      // 减去7天
      this.filters.startTime = util.formatDate.format(
        currentDate,
        "yyyy-MM-dd 00:00:00"
      );
    }
    if (!this.filters.endTime) {
      this.filters.endTime = util.formatDate.format(
        currentDate,
        "yyyy-MM-dd 23:59:59"
      );
    }
    const deepCopiedArray = JSON.parse(JSON.stringify(this.getSysOrgs));
    this.sysList = deepCopiedArray;
    if (this.sysList.length > 1) {
      this.sysList.unshift({ Id: 1, Name: "所有", OrgCode: "" });
    }
    this.getReportList();
  },
  computed: {
    ...mapGetters(["getSysOrgs", "getCurrentOrg"]),
  },
};
</script>

<style scoped>
.app-container {
  padding: 20px;
}
.filter-container {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.pagination-container {
  margin-top: 20px;
  text-align: right;
}
.el-divider {
  margin: 20px 0;
}
</style>
